import React from 'react';

// Galería tipo masonry (flujo Pinterest): todas las imágenes fluyen en columnas
// respetando su alto natural. El masonry se resuelve con CSS `columns` en
// Blog.css (.blog-gallery-grid), y aplica igual en desktop y móvil.
export default function BlogGalleryGrid({ data }) {
  const { images = [] } = data;
  if (!images.length) return null;

  return (
    <div className="blog-gallery-grid">
      {images.map((img, i) => (
        <img key={i} src={img.src} alt={img.alt || ''} className="blog-gallery-item" />
      ))}
    </div>
  );
}
